import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import ScrollView from '@hfe/max-scrollview';
import { createElement, memo, useEffect, useState, useRef, useCallback } from '@max/max';
import CalendarMonthHeader from './CalendarMonthHeader';
import CalendarDaysBody from './CalendarDaysBody';
import '../calendar.scss';
import { getStorage, setStorage } from '@max/meituan-uni-storage';
const isWeb = true;
const isMRN = false;
const CalendarBody = ({ calendarState, viewState, syncSelection, holidayState, isVisible }) => {
    const [isShowDawnTooltip, setDawnTooltipShow] = useState(false);
    const scrollViewRef = useRef(null);
    const monthPositions = useRef({});
    const monthRefs = useRef({});
    const prevVisibleRef = useRef(false);
    const syncToolTipStorage = (type, value) => {
        // console.log('syncToolTipStorage', type, value);
        setStorage({
            key: type,
            data: value
        });
    };
    useEffect(() => {
        getStorage({
            key: 'hotelCalendarTooltip__dawnTip'
        }).then(res => {
            if ((res === null || res === void 0 ? void 0 : res.data) === null) {
                setDawnTooltipShow(true);
            }
            else {
                setDawnTooltipShow(res === null || res === void 0 ? void 0 : res.data);
            }
        });
    });
    useEffect(() => {
        const isJustOpened = !prevVisibleRef.current && isVisible;
        prevVisibleRef.current = isVisible;
        if (!isJustOpened)
            return;
        const startDay = viewState === null || viewState === void 0 ? void 0 : viewState.startDay;
        if (!startDay || !scrollViewRef.current || !(calendarState === null || calendarState === void 0 ? void 0 : calendarState.length))
            return;
        const key = `${startDay.year}-${startDay.month}`;
        setTimeout(() => {
            if (isWeb) {
                const monthElement = monthRefs.current[key];
                if (monthElement && scrollViewRef.current) {
                    // @ts-expect-error
                    const scrollViewElement = scrollViewRef.current._nativeNode;
                    const monthElementRect = monthElement === null || monthElement === void 0 ? void 0 : monthElement.getBoundingClientRect();
                    const scrollViewRect = scrollViewElement === null || scrollViewElement === void 0 ? void 0 : scrollViewElement.getBoundingClientRect();
                    if (!monthElementRect || !scrollViewRect)
                        return;
                    scrollViewElement.scrollTo({
                        top: monthElementRect.top - scrollViewRect.top,
                        behavior: 'smooth'
                    });
                }
            }
            else {
                const y = monthPositions.current[key];
                if (y != null && scrollViewRef.current) {
                    // @ts-expect-error
                    scrollViewRef.current.scrollTo({
                        y,
                        animated: true
                    });
                }
            }
        }, 150);
    }, [isVisible, viewState === null || viewState === void 0 ? void 0 : viewState.startDay, calendarState]);
    const handleMonthLayout = useCallback((key, event) => {
        const { y } = event.nativeEvent.layout;
        monthPositions.current[key] = y;
    }, []);
    return <ScrollView className="calendar-main-container" ref={scrollViewRef}>
      <View>
        {calendarState && calendarState.map(currentCalendarState => {
        const key = `${currentCalendarState.year}-${currentCalendarState.month}`;
        return <View key={key} onLayout={(e) => handleMonthLayout(key, e)} ref={isWeb ? el => {
            if (el) {
                monthRefs.current[key] = el;
            }
        } : null}>
                <CalendarMonthHeader year={currentCalendarState.year} month={currentCalendarState.month}/>
                <CalendarDaysBody calendarState={currentCalendarState} viewState={viewState} onSyncSelection={syncSelection} holidayState={holidayState} onSyncStorage={syncToolTipStorage} isShowDawnTooltip={isShowDawnTooltip}/>
              </View>;
    })}
      </View>
      <Text className="calendar-main-tip-container">- 仅支持预订近半年的房间 -</Text>
    </ScrollView>;
};
export default memo(CalendarBody);
